import React, { Component, Fragment } from 'react';
import Switch from "react-switch";
import autoBind from 'react-autobind';

export default class ReactSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: props.checked,
      disabled: props.disabled
    }
    
    autoBind(this);
  }

  handleChange(checked) {
    const { parentStateHandler } = this.props;
    this.setState({ checked });
    parentStateHandler(checked);
  }

  render() {
    return (
      <Switch onChange={this.handleChange} checked={this.state.checked} disabled={this.state.disabled} />
    )
  }
}